import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconUndo: React.FC<IconProps> = ({ width = 16, height = 16, color = '#23262A' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M3.33398 5.83203H12.5007C14.8018 5.83203 16.6673 7.69751 16.6673 9.9987C16.6673 12.2999 14.8018 14.1654 12.5007 14.1654H6.66732M3.33398 5.83203L5.83398 3.33203M3.33398 5.83203L5.83398 8.33203"
                stroke={color}
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default IconUndo;
